import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgWizardService} from 'ng-wizard';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SearchRequestService} from '../../../../shared/service/search-request.service';
import {ApplicantRequestService} from '../../../../service/applicant-request.service';
import {HistoryModel} from '../../../../shared/dto/history.model';

@Component({
  selector: 'history-info',
  templateUrl: './history-info.component.html',
  styleUrls: ['./history-info.component.scss']
})

export class HistoryInfoComponent implements OnInit, AfterViewInit{
  @Input()applicationId: number;
  @Input() items: HistoryModel[] = [];
  @Input() index: number;
  @Input() page: number = 1;
  @Input() itemsPerPage: number = 10;
  @ViewChild(MatPaginator, {static:false}) paginator: MatPaginator;
  @ViewChild(MatSort,{static: false}) sort: MatSort;

  public item: HistoryModel[] = [];
  displayedColumns: string[] = ['requestID','stage','user','remark','desc','createdDate','lastUpdatedDate']
  dataSource: MatTableDataSource<any>;

  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              private spinnerService: NgxUiLoaderService,
              private requestSearchService: SearchRequestService,
              private applicantRequestService: ApplicantRequestService) { }


  ngOnInit() {
    this.loadData();
  }

  loadData(){
    console.log("Here");
    this.applicantRequestService.searchApplicantHistory(this.applicationId).subscribe(
      (data: HistoryModel[]) => {
        console.log('DATA' + data)
        this.item = data;
        this.dataSource = new MatTableDataSource(this.item);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(filterValue: string){
    this.dataSource.filter = filterValue.trim().toLocaleLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }

}
